import React from "react";
import { Tag, Typography } from "antd";
import moment from "moment";
import { CRIMINAL_STATUS } from "constants/common";
import { DATE_DISPLAY_FORMAT_HOURS } from "constants/dateFormats";

const { Paragraph } = Typography;

const CrimeRecord = ({ record }) => {
  const {
    crimeRecordStatus,
    crimeRecordTime = null,
    crimeRecordLocation = "",
    crimeRecordContent = "",
    crimeRecordPIC = "",
    crimeRecordAgency = "",
    crimeRecordContact = "-",
    customerCriminalRecordId = ''
  } = record;

  const renderStatusTag = () => {
    switch (crimeRecordStatus) {
      case CRIMINAL_STATUS.NO:
        return <Tag color="red">{CRIMINAL_STATUS.NO?.toUpperCase()}</Tag>;
      case CRIMINAL_STATUS.YES:
        return <Tag color="green">{CRIMINAL_STATUS.YES?.toUpperCase()}</Tag>;
      // case CRIMINAL_STATUS.API_ERROR:
      //   return (
      //     <Tag color="orange">{CRIMINAL_STATUS.API_ERROR?.toUpperCase()}</Tag>
      //   );
      default:
        return null;
    }
  };

  return (
    <div
      style={{
        borderBottom: "1px solid #ddd",
        paddingBottom: 16,
        marginBottom: 24,
      }}
    >
      <div style={{ marginBottom: 8 }}>
        <strong>Trạng thái:</strong> {renderStatusTag()}
      </div>

      <div style={{ marginBottom: 8 }}>
        <strong>Thông tin vi phạm:</strong>
        <Paragraph>
          {moment(crimeRecordTime).format(DATE_DISPLAY_FORMAT_HOURS)}
          <br />
          {crimeRecordLocation}
          <br />
          {crimeRecordContent}
        </Paragraph>
      </div>

      <div style={{ marginBottom: 8 }}>
        <strong>Đơn vị phát hiện vi phạm:</strong>
        <Paragraph style={{ margin: 0 }}>{crimeRecordPIC}</Paragraph>
      </div>

      <div style={{ marginBottom: 8 }}>
        <strong>Nơi giải quyết vụ việc:</strong>
        <Paragraph style={{ margin: 0 }}>
          {crimeRecordAgency || "-"}
          <br />
          Số điện thoại liên hệ: {crimeRecordContact || "-"}
          <br />
        </Paragraph>
      </div>
    </div>
  );
};

export default CrimeRecord;
